module.exports = __webpack_public_path__ + "static/media/angle-right.9d8ddf12.svg";